import { render, staticRenderFns } from "./About.vue?vue&type=template&id=4fab0b3e&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=4fab0b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fab0b3e",
  null
  
)

export default component.exports